@import '@hevoio/hevo-ui-toolkit/styles/variables';

.optionsContainer {
  display: flex;
  flex-wrap: wrap;
  gap: $spacer-8;
}

// Figma 8546-70475 "Buttons [1.1]": the frequency chips are the toolbar button —
// white surface, soft stroke, 8px radius, 36px control height, resting small
// shadow — and the selected one is the solid primary button.
.optionButton {
  height: $toolbar-control-size;
  padding: 0 $spacer-12;
  border: $border-width solid $stroke-soft-200;
  border-radius: $border-radius-lg;
  background-color: $bg-white-0;
  color: $text-sub-600;
  box-shadow: $shadow-regular-small;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background-color: $menu-active-bg;
  }

  &.active {
    background-color: $primary;
    border-color: $primary;
    color: $light-text;
    box-shadow: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
}

.optionBadgeLabel {
  margin-top: -7px !important;
  margin-left: -$spacer !important;
  border: solid var(--border-width) var(--surface-bg-color);
}
